var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2391 0.692871C21.3789 0.692871 19.595 1.42783 18.2796 2.73607C16.9643 4.04431 16.2254 5.81867 16.2254 7.6688C16.2254 7.85034 15.8868 7.95631 15.2946 7.95631C13.0299 7.95631 7.06261 6.40373 2.19793 1.56445C0.444501 5.05241 -0.432627 13.7731 10.9659 19.8775C7.01718 23.4361 2.5919 24.5623 0.166992 24.5632C0.261147 24.6995 0.341261 24.8425 0.44285 24.9747C2.52169 27.6749 6.5431 29.0262 10.9064 29.0262C15.1938 29.0262 19.8107 27.7217 23.2408 25.1094C28.4622 21.1335 30.2545 14.6447 30.2545 7.6688V6.7964L32.667 1.53406L27.5182 2.14852C26.2935 1.20497 24.7883 0.692925 23.2391 0.692871Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.c98452a46f7e3d1f4762912d343656b8.svg";
export { ForwardRef as ReactComponent };